import { useState, type InputHTMLAttributes, type ReactNode } from 'react'

import styles from './Input.module.css'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
  forceFocus?: boolean
  icon?: ReactNode
}

export function Input({ error = false, forceFocus = false, icon, className = '', onFocus, onBlur, ...props }: InputProps) {
  const [focused, setFocused] = useState(false)
  return (
    <div className={`${styles.frame} ${focused || forceFocus ? styles.focused : ''} ${error ? styles.error : ''} ${className}`}>
      <input
        className={styles.input}
        aria-invalid={error || undefined}
        onFocus={(event) => { setFocused(true); onFocus?.(event) }}
        onBlur={(event) => { setFocused(false); onBlur?.(event) }}
        {...props}
      />
      {icon ? <span className={styles.icon}>{icon}</span> : null}
    </div>
  )
}
